import { render, staticRenderFns } from "./databox.vue?vue&type=template&id=13c2fb80&"
import script from "./databox.vue?vue&type=script&lang=js&"
export * from "./databox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports